import type { KanbanColumnProps } from "./types-column";
import { useKanbanColumn } from "./use-column";
import { KanbanColumnView } from "./view-column";

/** Etapa: título, contador, lista com rolagem, vazio ("Nenhum item") e "Mostrar mais". */
export function KanbanColumn(props: KanbanColumnProps) {
  const viewModel = useKanbanColumn(props);

  return <KanbanColumnView {...viewModel} />;
}
KanbanColumn.displayName = "Kanban.Column";
